/* eslint-disable no-return-assign */
import { Avatar, Flex, Text } from '@chakra-ui/react'
import { FaFile, FaFileCsv, FaFileDownload, FaFileExcel, FaFilePdf, FaFileVideo, FaFileWord, FaTrashAlt } from 'react-icons/fa'
import { DetalheArquivo } from '../../../../../../components/DetalheArquivo'
import { ElementoTooltipCmp } from '../../../../../../components/ElementoTooltipCmp'
import { parseJwt } from '../../../../../../services/token'
import { iAnexoAcao } from '../../../../Criar'

interface iProps {
  evidencia: iAnexoAcao
  onExcluir: (id: string) => void
}

const EXTENSOES_IMAGEM = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp', 'bmp']

export const CardEvidencia: React.FC<iProps> = ({ evidencia, onExcluir }) => {
  const extensao = (evidencia.anexo.name.split('.').pop() ?? '').toLowerCase()

  function GetFileIcon(): any {
    switch (extensao) {
      case 'xls':
      case 'xlsx':
        return <FaFileExcel size={28} color='var(--Green2)' />
      case 'csv':
        return <FaFileCsv size={28} color='var(--Green2)' />
      case 'pdf':
        return <FaFilePdf size={28} color='var(--Red)' />
      case 'doc':
      case 'docx':
        return <FaFileWord size={28} color='var(--Blue1)' />
      case 'mp3':
      case 'mp4':
      case 'mov':
        return <FaFileVideo size={28} color='var(--Roxo)' />
      default:
        return <FaFile size={28} color='var(--Gray3)' />
    }
  }

  return (
        <Flex padding={'0.5rem'} gap={'.5rem'} border={'1px solid var(--c4)'} flexDir={'column'} bg={'var(--AzulOpacoBg)'}>
            <Flex justifyContent={'space-between'}>
                <Flex gap={'.5rem'} alignItems={'center'}>
                    <Avatar src={evidencia.colaborador?.avatar} name={evidencia.colaborador?.nome} size={'xs'} />
                    <Text fontWeight={'600'} fontSize='12px'>{evidencia.colaborador?.nome}</Text>
                    {evidencia.data && <Text fontSize='12px' color={'var(--Gray3)'}>em {evidencia.data} às {evidencia.hora}</Text>}
                </Flex>
                <Flex gap={'.5rem'} cursor='pointer'>
                    <ElementoTooltipCmp bg={'var(--Azul)'} label={'Baixar evidência'}>
                        <FaFileDownload onClick={() => window.location.href = evidencia.anexo.uri} color='var(--Blue1)' />
                    </ElementoTooltipCmp>

                    {parseJwt().cid === evidencia.colaborador?.id &&
                        <ElementoTooltipCmp bg={'var(--Red)'} label={'Excluir'}>
                            <FaTrashAlt onClick={() => onExcluir(evidencia.id)} color='var(--Red)' />
                        </ElementoTooltipCmp>
                    }
                </Flex>
            </Flex>
            {EXTENSOES_IMAGEM.includes(extensao)
              ? <DetalheArquivo arquivo={evidencia.anexo} />
              : <Flex gap={'1rem'} alignItems={'center'} p={'.5rem'}>
                  {GetFileIcon()}
                  <Flex flexDir={'column'}>
                    <Text fontWeight={'700'} color={'var(--Azul)'} fontSize={'14px'}>{evidencia.anexo.name}</Text>
                    <small>Tamanho: {evidencia.anexo.size}</small>
                  </Flex>
                </Flex>
            }
        </Flex>
  )
}
